import { match as poiCategory } from "../../../src/params/poiCategory.ts";

export const matchers = { poiCategory };